import { useEffect, useRef } from 'react';
import FilterWrapper from '../../../components/generic/FilterUI/FilterWrapper';
import useToggler from '../Utils/useToggler';
import { filterWrapperDropdownAlignment } from '../../../components/generic/FilterUI/constants';

const useFilterWrapper = (wrapperInitialOptions = {}) => {
  const {
    showContent: showBody,
    setShowContent: setShowBody,
    contentRef: wrapperRef,
    showContentToggler: showBodyToggler
  } = useToggler({
    showByDefault: wrapperInitialOptions.openByDefault,
    openFollowups: wrapperInitialOptions.openFollowups
  });

  const focusRef = useRef(null);

  let alignmentOptions = {};
  if (wrapperInitialOptions.alignment === filterWrapperDropdownAlignment.RIGHT) {
    alignmentOptions = { additionalWrapperClass: 'position-relative', bodyClass: 'dropdown-menu-right' }
  }

  const wrapperControlOptions = {
    showBody,
    setShowBody,
    wrapperRef,
    showBodyToggler,
    focusRef
  };

  const wrapperOptions = {
    ...wrapperInitialOptions,
    ...wrapperControlOptions,
    ...alignmentOptions
  };

  useEffect(() => {
    if (focusRef.current) {
      showBody ? focusRef.current.focus() : focusRef.current.blur();
    }
  }, [showBody]);

  const wrapperActions = {
    filterBodyVisibilitySetter: setShowBody
  };

  return [
    FilterWrapper,
    wrapperOptions,
    wrapperActions
  ];
};

export default useFilterWrapper;
